/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import {
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography
} from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  Types */
import { Tenant } from 'application/Shared/types/tenant';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageWorkatoManifests } from '../../SaasOps/ManageManifests/Components/ManageWorkatoManifests';
import { CustomAccordion } from './Shared/CustomAccordion';

export const UpdateWorkatoManifest = ({ tenant }: { tenant: Tenant }) => {
    const { t } = useTranslation();

    return (
        <CustomAccordion>
            <AccordionSummary
                expandIcon={
                    <IconWithVariant
                        data-testid="expandAccordionIcon"
                        variant="primary"
                        src="ChevronDown"
                        size={FontSizes[2]}
                    />
                }
            >
                <Box display="flex" alignItems="center">
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {t('GlobalAdmin.Tenant.Edit.UpdateManifest.title')}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <ManageWorkatoManifests
                    platformTenantIds={[tenant.id]}
                    disableS3Upload
                    region={tenant.region}
                />
            </AccordionDetails>
        </CustomAccordion>
    );
};
